export const name = (value) => {
  if (value === "" || !value) {
    return "Invalid deco name";
  }
  return null;
};

export const hyphanateName = (value) => {
  if (value === "" || !value) {
    return "Invalid deco hyphanate name";
  }
  return null;
};

export const ppcName = (value) => {
  if (value === "" || !value) {
    return "Invalid ppc feed name";
  }
  return null;
};

export const productExamples = (value) => {
  if (value === "" || !value) {
    return "Invalid deco product examples";
  }
  return null;
};

export const colorsMax = (value) => {
  if (value === "" || !value) {
    return "Invalid deco color max value";
  }
  return null;
};

export const colorPricingCategoryID = (value) => {
  if (value === "" || !value) {
    return "Invalid deco color pricing category";
  }
  return null;
};
